import { render, staticRenderFns } from "./requestScanUpload.vue?vue&type=template&id=19ccbefc&"
import script from "./requestScanUpload.vue?vue&type=script&lang=js&"
export * from "./requestScanUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports